import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar/index";
import Tabs from "@material-ui/core/Tabs/index";
import Tab from "@material-ui/core/Tab/index";
import { makeStyles } from '@material-ui/core/styles';
import { getThemeColor, getThemeColorValue, theme as Styles } from "../theme/color";
import { getFontSize } from "../theme/font";
import { Scrollbar } from '../Scrollbar';
import { invalid } from '../../utils/common';
import { Principal } from "@codeArt/auth";
import { Panel } from "./common";
let _loadedTabs = {};

function loadedTab(key, loaded) {
    if (invalid(loaded)) return _loadedTabs[key];
    if (loaded) _loadedTabs[key] = true;
    else delete _loadedTabs[key];
}

class TabContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let { tabKey } = this.props;
        loadedTab(tabKey, true);
    }

    componentWillUnmount() {
        let { tabKey } = this.props;
        loadedTab(tabKey, false);
    }

    render() {
        let { children, hidden } = this.props;
        return <div className={`flex-column c-flex-1 ${hidden ? 'd-none' : 'd-flex'} h-100`}>
            {children}
        </div>;
    }
}

const navStyles = makeStyles(theme => ({
    appBar: props => {
        return {
            height: "100%",
            width: props.tabsWidth || "200px",
            background: "#fff",
            boxShadow: "none",
            borderRight: `1px solid ${getThemeColorValue("line")}`,
            "& .MuiTabs-indicator": {
                display: "none"
            }
        }
    },
    tabs: props => {
        return {
            "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                // color: Styles.color.white,
            },
            "& .MuiTab-wrapper": { //非活跃点颜色
                width: "auto",
                flexDirection: "row",
                alignItems: "flex-start!important"
            },
            // "& .MuiTouchRipple-root": { //禁用水波纹点击效果，经过测试发现，禁用的不彻底
            //     position: "unset",
            // },
            "& .Mui-selected": {  //活跃点（选中的文字icon颜色）
                background: getThemeColorValue(props.activeColor) || getThemeColorValue("light-primary")
            },
            "& .Mui-selected:hover": {  //活跃点（选中的文字icon颜色）
                background: getThemeColorValue(props.activeColor) || getThemeColorValue("light-primary")
            },
        }
    },
    tab: props => {
        return {
            justifyContent: "space-between !important",
            opacity: 1,
            color: getThemeColorValue(props.textColor) || Styles.color.dark,
            fontSize: getFontSize("s1d5"),
            "&:hover": {
                // color: Styles.color.white,
                background: getThemeColorValue(props.activeColor) || "rgba(0, 0, 0, 0.04)"
            },
            "& .MuiSvgIcon-root": {
                fontSize: "1.22rem",
                marginBottom: "0!important",
                marginRight: "0.2rem!important"
            },
            borderRadius: "0rem!important",
            minHeight: "auto!important",
            minWidth: "auto!important",
            padding: "16px",
            marginLeft: "0rem",
            marginRight: "0rem",
            marginTop: "0rem",
            marginBottom: "0rem"
        };
    }
}));

const lineStyles = makeStyles(theme => ({
    appBar: props => {
        return {
            boxShadow: "none",
            backgroundColor: getThemeColor(props.background, "value") || "transparent",
            "& .MuiTabs-indicator": {
                background: getThemeColorValue(props.activeColor) || Styles.color.primary
            }
        }
    },
    tabs: props => {
        return {
            borderBottom: `1px solid ${props.activeColor ? getThemeColorValue(props.activeColor) : theme.palette.divider}`,
            "& .MuiTab-wrapper": { //非活跃点颜色
                color: getThemeColorValue(props.textColor) || Styles.color.default,
                flexDirection: "row",
                alignItems: "center!important",
                opacity: 1,
            },
            "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                fontWeight: props.activeWeight || "normal",
                color: getThemeColorValue(props.activeColor) || Styles.color.primary,
            },
            // "& .MuiTouchRipple-root": { //禁用水波纹点击效果，经过测试发现，禁用的不彻底
            //     position: "unset",
            // },
        }
    },
    tab: props => {
        return {
            minWidth: "auto!important",
            opacity: 1,
            fontSize: props.textSize || "1rem",
            "&:hover": {
                color: getThemeColorValue(props.activeColor) || Styles.color.primary,
                fontSize: props.indicatorTextSize
            },
            "& .MuiSvgIcon-root": {
                fontSize: "1.45rem",
                marginBottom: "0px!important",
                marginRight: "0.2rem!important"
            },
            minHeight: "auto",
            paddingTop: props.paddingTop || "1.1rem",
            paddingBottom: props.paddingBottom || "1.1rem",
            paddingLeft: "0",
            paddingRight: "0",
            marginRight: props.centered ? "0rem" : (props.itemSpace || "2rem")
        };

    }
}));

const normalStyles = makeStyles(theme => ({
    appBar: props => {
        return {
            backgroundColor: getThemeColor(props.background, "value") || Styles.color.primary,
            "& .MuiTabs-indicator": {
                background: getThemeColorValue(props.activeColor) || Styles.color.primary
            }
        }
    },
    tabs: props => {
        return {
            "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                fontWeight: props.activeWeight || "normal",
                color: getThemeColor(props.activeColor, "value") || Styles.color.white,
            },
            "& .MuiTab-wrapper": { //非活跃点颜色
                color: getThemeColor(props.textColor, "value") || Styles.color.light,
            },
        }
    },
    tab: props => {
        return {
            fontSize: props.textSize || "auto",
            paddingTop: props.paddingTop || '',
            paddingBottom: props.paddingTop || '',
        }
    }
}));

const themeStyles = { "nav": navStyles, 'line': lineStyles, 'normal': normalStyles };

function VerticalTabs(props) {

    let { theme, match, history, className, selectedIndex, onChange, items, full, headerClassName, containerScrollable, disableRipple, tools, keep, centered, bodyFull } = props;
    if (theme == "line") {
        disableRipple = true; //line风格下，不显示点击水波纹效果
    }

    items = items.filter((t) => {
        if (t.auth)
            return Principal.verify(t.auth);
        else
            return true;
    });

    let hasIcon = items.filter((t) => t.icon).length > 0;

    const classes = themeStyles[theme]({ ...props, hasIcon });
    const [value, setValue] = React.useState(0);

    const handleChange = (event, value) => {
        setValue(value);
        if (onChange)
            onChange(value);
    };

    const getBody = (item, ctx) => {
        let { body } = item;
        var type = type(body);
        if (type == "function") {
            return body({ item, ctx });
        }
        return body;
    }

    let current = selectedIndex == 0 ? selectedIndex : selectedIndex || value;

    const tabs = () => {
        return <Tabs
            className={classes.tabs}
            orientation={'vertical'}
            value={current}
            centered={centered}
            onChange={handleChange}
            variant={full || centered ? 'fullWidth' : 'scrollable'}
            scrollButtons={"auto"}
        >
            {
                items.map((t, i) => {
                    let p = { ...t };
                    delete p.container; delete p.cache; delete p.body; delete p.tools;
                    return <Tab className={classes.tab} key={i} disableRipple={disableRipple} {...p} />
                })
            }
            {tools ? <Panel>{tools}</Panel> : null}
        </Tabs>;
    }

    const tryScrollable = (content) => {
        if (!containerScrollable) return content;
        return (
            <div className="d-flex c-flex-1">
                <Scrollbar>
                    {content}
                </Scrollbar>
            </div>
        );
    }

    return (
        <div className={`d-flex flex-row w-100 ${containerScrollable || bodyFull ? 'h-100' : ''} ${className}`}>
            <AppBar position="static" color="default" className={`d-flex ${classes.appBar} ${headerClassName}`}>
                {tabs()}
            </AppBar>
            {
                keep ? (
                    tryScrollable(items.map((t, i) => {
                        let tabKey = `${t.label}_${i}`;
                        if (loadedTab(tabKey) || current === i) {
                            return <TabContainer tabKey={tabKey} hidden={current != i} key={i}>{getBody(t, { match, history })}</TabContainer>;
                        }
                    }))
                ) : (
                    tryScrollable(items.map((t, i) => {
                        return (current === i && <TabContainer key={i}>{getBody(t, { match, history })}</TabContainer>)
                    }))
                )
            }
        </div>
    );
}

export { VerticalTabs };

VerticalTabs.defaultProps = {
    theme: "slim",
    full: false,
    className: '',
    headerClassName: '',
    disableRipple: false,
    keep: false
}
